import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

export function setTriageBio({ props, actions }) {

  if (props.birthdate) {

    const { year, month, day } = props.birthdate
    const birthdate = new Date(year, month - 1, day)
    const today = new Date()

    props.ageInYears = differenceInCalendarYears(today, birthdate)
    props.ageInDays = differenceInCalendarDays(today, birthdate)
  }

  actions.setTriageRequest(props)
}
